var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUUserPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 16,
    fill: "url(#paint0_linear_482_3757)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 19C16.4294 19.5741 16.9773 20.0491 17.6065 20.3929C18.2357 20.7367 18.9315 20.9411 19.6466 20.9923C20.3617 21.0435 21.0795 20.9403 21.7513 20.6897C22.4231 20.4392 23.0331 20.047 23.54 19.54L26.54 16.54C27.4507 15.597 27.9547 14.3339 27.9433 13.023C27.9319 11.712 27.4061 10.4579 26.479 9.53087C25.552 8.60383 24.2979 8.07799 22.987 8.0666C21.676 8.0552 20.413 8.55918 19.47 9.46997L17.75 11.18M20 17C19.5705 16.4258 19.0226 15.9508 18.3934 15.607C17.7642 15.2633 17.0684 15.0588 16.3533 15.0076C15.6382 14.9564 14.9204 15.0596 14.2486 15.3102C13.5769 15.5608 12.9668 15.9529 12.46 16.46L9.45996 19.46C8.54917 20.403 8.04519 21.666 8.05659 22.977C8.06798 24.288 8.59382 25.542 9.52086 26.4691C10.4479 27.3961 11.702 27.9219 13.0129 27.9333C14.3239 27.9447 15.5869 27.4408 16.53 26.53L18.24 24.82",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_482_3757",
    x1: 18,
    y1: -0.00000107288,
    x2: 18,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#008500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.985,
    stopColor: "#008500"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUUserPlus);
export default __webpack_public_path__ + "static/media/u_user-plus.5ea1563951668b465d58b0e37957fcd9.svg";
export { ForwardRef as ReactComponent };